import { Box, Stack } from '@mui/material';
import { FC, useMemo } from 'react';
import { useTranslate } from 'react-admin';

import { InvestorProfileGridInstrumentAllocation } from '@sh4res/bo-common/resources/investor_profile/components/B2bInvestorProfileGrid/helpers/transformBoGridToFormGrid';

interface Props {
  currentGrid: InvestorProfileGridInstrumentAllocation[];
}

export const B2bInvestorProfileGridOrdinatesColumn: FC<Props> = (props) => {
  const { currentGrid } = props;

  const translate = useTranslate();

  const currentGridAllocation = useMemo(() => currentGrid.at(0)?.allocation ?? [], [currentGrid]);

  return (
    <Stack spacing={1.45}>
      <Box height={107} width={130} alignItems="center">
        <span style={{ fontWeight: 'bold' }}>
          {translate(
            'resources.bo_common.b2b.investor_profile.create.grid_configuration.years_before_retirement',
          )}
        </span>
      </Box>
      {currentGridAllocation.map((_, index) => (
        <Box key={index} height={58} width={130} alignContent="center">
          <span style={{ color: '#00008F' }}>{currentGridAllocation.length - (index + 1)}</span>
        </Box>
      ))}
    </Stack>
  );
};
